





































import {Component, Prop } from 'vue-property-decorator';
import TopPart from "./components/top/CommitteeCardTop.vue";
import CardFooter from "./components/footer/CommitteeCardFooter.vue";

import { TicketType } from '@share/ticketSystem/enums/TicketTypes';
import { CommitteeModel } from '@api/models/committees/CommitteeModel';
import TimeCardBase from '@share/common/cards/time-card/TimeCardBase.vue';
import { UserProfile } from '@api/models/UserProfile';
import { MenuEvent } from '@api/enums/MenuEvents';
import { getFullCompanyName } from '@common/CompanyHelper';

@Component({
    components: { TopPart, CardFooter }
})
export default class CommitteeCard extends TimeCardBase {
    @Prop() declare source: CommitteeModel;
    @Prop({ default: () => [] }) userProfiles: UserProfile[];
    @Prop() isAdmin: boolean;

    readonly title_class = "committee-card__title";

    MenuEvent = MenuEvent;

    deleteCommittee() {
        this.deleted = true;
        this.$emit(MenuEvent.delete, this.source.id);
    }

    get title() {
        return this.source.title
    }

    get companyName() {
        return getFullCompanyName(this.source.company);
    }

    get categoryStyles() {
        switch (this.subjectType) {
            case TicketType.idea:
                return {
                    color: '#19CEAD'
                }
            case TicketType.problem:
                return {
                    color: '#E8B73D'
                }
            default:
                return ""
        }
    }

    get typeString() {
        const hasTickets = !!this.source.ticketIds?.length;

        switch (this.subjectType) {
            case TicketType.idea:
                return hasTickets ? this.$t("common.ticketSystemIdeas") : this.$t("tickets.columns.idea");
            case TicketType.problem:
                return hasTickets ? this.$t("common.ticketSystemProblems") : this.$t("tickets.columns.problem");

            default:
                return ""
        }
    }

    get typeStringWithCount() {
        return `${this.typeString} ${ this.source.ticketIds?.length ? `(${this.source.ticketIds.length})` : '' }`
    }

    //OWN:
    get subjectType() {
        return this.source.subjectType
    }
}

